import {format} from "date-fns";
import type React from "react";
import {memo, useMemo} from "react";

import {ChevronLeftIcon, ChevronRightIcon} from "../../react/components/Icons";
import ButtonIconTooltip from "../ButtonIconTooltip";
import {Button, ButtonText} from "../ui/button";
import {HStack} from "../ui/hstack";
import {Text} from "../ui/text";

type Props = {
    onMovePrev: () => void;
    onMoveNext: () => void;
} & StrictUnion<
    | {
          onToday: () => void;
      }
    | {
          currentDate: Date;
      }
>;

const MonthNavigator: React.FC<Props> = ({currentDate, onToday, onMovePrev, onMoveNext}) => {
    const formattedCurrentDay = useMemo(
        () => (currentDate ? format(currentDate, "MMM") : undefined),
        [currentDate]
    );

    return (
        <HStack className="items-center justify-between" space="xs">
            <ButtonIconTooltip
                className="rounded-full bg-blueGray-200 dark:bg-dark-muted"
                icon={ChevronLeftIcon}
                placement="left"
                size="sm"
                testID="btn-prev-month"
                tooltip="Previous month"
                onPress={onMovePrev}
            />
            {formattedCurrentDay && (
                <Text textAlign="center" variant="lg">
                    {formattedCurrentDay}
                </Text>
            )}
            {onToday && (
                <Button no110MinWidth size="sm" variant="ghost" onPress={onToday}>
                    <ButtonText>Today</ButtonText>
                </Button>
            )}
            <ButtonIconTooltip
                className="rounded-full bg-blueGray-200 dark:bg-dark-muted"
                icon={ChevronRightIcon}
                placement="left"
                size="sm"
                testID="btn-next-month"
                tooltip="Next month"
                onPress={onMoveNext}
            />
        </HStack>
    );
};

export default memo(MonthNavigator);
